// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"7749c369","917":"0e962cf9"}[chunkId] + ".chunk.js";
};